import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_4 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = {
  key: 1,
  class: "form-messages mt-2 px-1"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_16 = {
  key: 1,
  class: "form-messages mt-2 px-1"
}
const _hoisted_17 = {
  key: 1,
  class: "col-12"
}
const _hoisted_18 = { class: "mb-15 mb-md-20 mb-lg-25" }
const _hoisted_19 = ["for"]
const _hoisted_20 = ["id", "required"]
const _hoisted_21 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = {
  key: 2,
  class: "col-12"
}
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = {
  key: 3,
  class: "col-12"
}
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "d-flex justify-content-between" }
const _hoisted_29 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_30 = {
  key: 0,
  class: "ph ph-code"
}
const _hoisted_31 = {
  key: 1,
  class: "mb-0 quill-editor"
}
const _hoisted_32 = {
  key: 2,
  class: "form-messages mt-2 px-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_ctx.local_block !== undefined && _ctx.lang != undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" TYPE "),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('feature.contents.$blocks.type')) + "* ", 1 /* TEXT */),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.value }]]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.local_block.type) = $event)),
                required: "",
                disabled: _ctx.update,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetBlock()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.block_types, (block_type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: block_type,
                    key: block_type
                  }, _toDisplayString(_ctx.$t(`feature.contents.$blocks.$type.${block_type}`)), 9 /* TEXT, PROPS */, _hoisted_6))
                }), 128 /* KEYED_FRAGMENT */))
              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5), [
                [_vModelSelect, _ctx.local_block.type]
              ]),
              _createCommentVNode(" ERRORS "),
              (_ctx.errors?.type ?? false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.type, (error) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: error,
                        class: "small text-danger lh-1 m-0 mt-1"
                      }, _toDisplayString(error), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _hoisted_8,
        _createCommentVNode(" TITLE "),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.subtitle.label')) + "* ", 1 /* TEXT */),
            (_ctx.local_block.subtitle?.[_ctx.lang] !== undefined)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.local_block.subtitle![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.subtitle }]])
                }, null, 2 /* CLASS */)), [
                  [_vModelText, _ctx.local_block.subtitle![_ctx.lang]]
                ])
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ERRORS "),
            (_ctx.errors?.subtitle ?? false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.subtitle, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "small text-danger lh-1 m-0 mt-1"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" VALUE "),
        _createCommentVNode(" TEXT "),
        (_ctx.local_block.type === 'text')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('form.value.label')) + "* ", 1 /* TEXT */),
                (_ctx.local_block.value?.[_ctx.lang] !== undefined)
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.local_block.value![_ctx.lang]) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.value }]]),
                      rows: "6",
                      required: ""
                    }, null, 2 /* CLASS */)), [
                      [_vModelText, _ctx.local_block.value![_ctx.lang]]
                    ])
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.value ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" IMAGE "),
        (_ctx.local_block.type === 'image')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", {
                  class: "d-block text-black fw-semibold mb-10",
                  for: _ctx.block.type
                }, _toDisplayString(_ctx.$t('form.value.label')) + "* ", 9 /* TEXT, PROPS */, _hoisted_19),
                _createElementVNode("input", {
                  class: "form-control fs-15 text-black shadow-none",
                  type: "file",
                  id: _ctx.block.type,
                  required: !_ctx.update,
                  onChange: _cache[4] || (_cache[4] = event => _ctx.fileUploaded(event)),
                  accept: "image/png, image/jpeg"
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.value ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" VIDEO "),
        (_ctx.local_block.type === 'video')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.url.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.local_block.value![_ctx.lang]) = $event)),
                  type: "url",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.value }]]),
                  rows: "6",
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.local_block.value![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.value ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" HTML "),
        (_ctx.local_block.type === 'html')
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('form.value.label')) + "* ", 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: "icon-link transition mb-10 cursor-pointer text-uppercase",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleRawEdit && _ctx.toggleRawEdit(...args)))
                  }, [
                    (!_ctx.raw_edit)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.raw_edit ? _ctx.$t('feature.contents.$blocks.editor') : _ctx.$t('feature.contents.$blocks.raw')), 1 /* TEXT */)
                  ])
                ]),
                _createCommentVNode(" RAW EDIT "),
                (_ctx.raw_edit)
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.local_block.value![_ctx.lang]) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.value }]]),
                      rows: "8",
                      required: "",
                      key: `${_ctx.block.id}-${_ctx.lang}-${_ctx.changes}-input`,
                      onPaste: _cache[8] || (_cache[8] = (e) => _ctx.minify_value(e))
                    }, null, 34 /* CLASS, NEED_HYDRATION */)), [
                      [_vModelText, _ctx.local_block.value![_ctx.lang]]
                    ])
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (_openBlock(), _createBlock(_component_QuillEditor, {
                        theme: "snow",
                        toolbar: _ctx.toolbar,
                        content: _ctx.local_block.value![_ctx.lang],
                        "onUpdate:content": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.local_block.value![_ctx.lang]) = $event)),
                        contentType: "html",
                        output: "delta",
                        key: `${_ctx.block.id}-${_ctx.lang}-${_ctx.changes}-editor`
                      }, null, 8 /* PROPS */, ["toolbar", "content"]))
                    ])),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.value ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}